import React, { Component } from 'react';
import './JobStatus.css';
import JobStatusBox from './JobStatusBox'
import JobInfoBox from './JobInfoBox';

class JobStatus extends Component {
    state = {
        loading : true,
        nextStep: "This is the next step of the job.",
        progressLength: "progress-bar-10", 
        jobStatus: this.props.jobstatus,
        jobInformation: '',
        nextStep: '',
        nextStepTitle: '',
        siteAuditDisplay: 'none',
        engineeringDisplay: 'none',
        permittingDisplay: 'none',
        installDisplay: 'none',
        ptoDisplay: 'none',
        powerOnDisplay: 'none',
        progressBar: '',
        
    }

    componentWillMount(){
        this.setUp();
        console.log(this.state.jobStatus)
    }
    
    setUp = () => {
        
        if(this.props.jobstatus === "Counter Signed"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                siteAuditDisplay: 'block',
                progressBar: 'progress-siteAudit'
            })
        }
       else if(this.props.jobstatus === "Engineering"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                engineeringDisplay: 'block',
                progressBar: 'progress-engineering'

            })
        }
     
        else if(this.props.jobstatus === "Permitting"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                permittingDisplay: 'block',
                progressBar: 'progress-permitting'
            })
        }
        else if(this.props.jobstatus === "Install"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                installDisplay: 'block',
                progressBar: 'progress-install'

            })
        }
        else if(this.props.jobstatus === "PTO"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                ptoDisplay: 'block',
                progressBar: 'progress-pto'
            })
        }
        else if(this.props.jobstatus === "Power On"){
            this.setState({
                jobInformation: '',
                nextStep: '',
                nextStepTitle: '',
                powerOnDisplay: 'block',
                progressBar: 'progress-powerOn'
                
            })
        }
        else if(this.props.jobstatus === "Complete"){}
    }

    render() { 
        return ( 
            <div className="container addMargin">
                <h2 className="miniHeadings" style={{marginLeft: "10px", marginBottom: "0"}}>Job Status <span id="titleSpan"></span></h2>
                <div className="container">
                    <div className="row text-center timelineRow">
                    
                        <div className="bar"><div className={this.state.progressBar}></div></div>
                            <JobStatusBox class="statusTag-siteAudit"  status="Site Audit"  display={this.state.siteAuditDisplay}/>
                            <JobStatusBox class="statusTag-engineering"  status="Engineering" display={this.state.engineeringDisplay}/>
                            <JobStatusBox class="statusTag-permitting"  status="Permitting"  display={this.state.permittingDisplay}/>
                            <JobStatusBox class="statusTag-install" status="Install"  display={this.state.installDisplay}/>
                            <JobStatusBox class="statusTag-pto"  status="PTO"  display={this.state.ptoDisplay}/>
                            <JobStatusBox class="statusTag-powerOn"  status="Power On"  display={this.state.powerOnDisplay}/>
                        </div>
                    </div>
                    <div className="row addSpacing">
                        <JobInfoBox title="My Job Information" bodyTitle={"In " + this.state.jobStatus} body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."/>
                        <JobInfoBox title="Next Steps" bodyTitle="Permitting is the Next Step" body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur." />
                    </div>
                </div>
        )
    }
}


export default JobStatus;



// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/JobStatus/JobStatus.jsx